import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { ItemCategoryService, ItemService } from 'src/generated_client';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.css']
})

export class EditProductComponent implements OnInit {

  id: any;
  store: any;
  allCategories: CategoryOption[] = [];

  status = [
    { value: true, viewValue: 'Activo' },
    { value: false, viewValue: 'Desactivado' },
  ];

  editProductForm: FormGroup = this.fb.group({
    cdItem: [],
    cdStore: [],
    categoria: ['', Validators.required],
    nombre: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, WhiteSpaceValidator.cannontStartWithSpace])],
    descripcion: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, WhiteSpaceValidator.cannontStartWithSpace])],
    estado: ['', Validators.required],
    imagen: [''],
    orden: ['', Validators.required],
    textP: [''],
    textM: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, WhiteSpaceValidator.cannontStartWithSpace])],
    textG: [''],
    precioP: [],
    precioM: ['',Validators.compose([Validators.required, Validators.min(1)])],
    precioG: [],
    banner: [false, Validators.required]
  });

  constructor(
    public itemService: ItemService,
    public itemCategoryService: ItemCategoryService,
    public authService: AuthService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private snackBar: SnackBarService
  ) { }

  ngOnInit() {

    this.id = this.activatedRoute.snapshot.paramMap.get("id");
    this.store = this.authService.currentUserStore();


    this.itemService.apiItemGetCdItemGet(this.id).subscribe(item => {

      this.editProductForm.controls['cdItem'].setValue(Number(this.id));
      this.editProductForm.controls['nombre'].setValue(item.dsName);
      this.editProductForm.controls['categoria'].setValue(item.cdItemsCategory);
      this.editProductForm.controls['descripcion'].setValue(item.dsDescription);
      this.editProductForm.controls['estado'].setValue(item.isActive);
      this.editProductForm.controls['orden'].setValue(item.nmSortNo);

      if (item.dsSmallText != 'null')
        this.editProductForm.controls['textP'].setValue(item.dsSmallText);

      if (item.dsLargeText != 'null')
        this.editProductForm.controls['textG'].setValue(item.dsLargeText);

      this.editProductForm.controls['textM'].setValue(item.dsMediumText);
      this.editProductForm.controls['precioP'].setValue(item.qtSmallPrice);
      this.editProductForm.controls['precioM'].setValue(item.qtMediumPrice);
      this.editProductForm.controls['precioG'].setValue(item.qtLargePrice);
      this.editProductForm.controls['cdStore'].setValue(item.cdStore);
      this.editProductForm.controls['banner'].setValue(item.isBanner);
    });

    this.itemCategoryService.apiItemCategoryGetAllGet(this.store.cdStore).subscribe(categories => {
      categories.forEach(c => {
        let category: CategoryOption;
        category = {
          id: Number(c.cdItemsCategory),
          name: String(c.dsTitle)
        }
        this.allCategories.push(category)
      });
    });
  }

  saveChanges(form: any) {

    var imagen: File = form.imagen?._files;

    if (imagen != undefined)
      imagen = form.imagen?._files[0];

    this.itemService.apiItemPutPutForm(form.cdItem, form.cdStore, form.categoria, form.nombre, form.descripcion, undefined, form.precioP?.value, form.precioM,
      form.precioG?.value, form.orden, undefined, form.textP, form.textM, form.textG, undefined, form.estado, imagen, form.banner).subscribe(() => {
        this.router.navigate(['product-management']);
        this.snackBar.openSnackBar('Los cambios se guardaron correctamente', 'Aceptar')
      },
        err => {
          this.snackBar.openSnackBar(err.error.error, 'Aceptar')
        }
      );
  }

  
}

interface CategoryOption {
  id: number;
  name: string;
}
